import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/products/application-platform/hosted-databases",
)({
  beforeLoad: () => {
    throw redirect({ to: "/products/web-hosting/shared-hosting" });
  },
});
